import categoriesJson from '@/content/categories.json';
import type { Category } from '@/types/catalog';

/**
 * Portas de entrada do catálogo mostradas na home.
 *
 * Cada `query` é anexada a `/catalogo`, então os cards e o painel de filtros
 * sempre concordam sobre o mesmo contrato de URL.
 *
 * Dados em `src/content/categories.json`, editáveis pelo painel em /admin.
 */
export const CATEGORIES = categoriesJson as Category[];
